




















































import { mapGetters } from 'vuex';

import {
  getLiveKitCredentialsConfiguration,
  updateLiveKitCredentialsConfiguration
} from '@/api/CopyStake/Settings';
import {
  TCopyStakeSettingsLiveKitCredentialsResponse,
  TCopyStakeSettingsLiveKitCredentialsPayload
} from '@/api/schema';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import { cloneDeep, isEqual } from 'lodash';
import type { AxiosError } from 'axios';

export default {
  name: 'CopyStakeSettingsLiveKitCredentials',
  data(): any {
    return {
      credentialsSavedData: {
        credentialsKey: '',
        credentialsSecret: '',
        streamUrl: ''
      },
      credentials: {
        credentialsKey: '',
        credentialsSecret: '',
        streamUrl: ''
      },

      credentialsShow: {
        secretKey: true,
        apiKey: true
      },

      isLoading: false,
      formValid: false
    };
  },
  props: {
    title: {
      type: String,
      default: (): string => ''
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },

    credentialsChanged(): boolean {
      return !isEqual(this.credentials, this.credentialsSavedData);
    },
    valueCanBeSaved(): boolean {
      return this.formValid && this.credentialsChanged;
    }
  },
  watch: {
    operatorId: {
      handler: 'getConfiguration',
      immediate: true
    }
  },
  methods: {
    getHiddenAttrs(key: string): any {
      const label = key === 'apiKey' ? 'API Key' : 'Secret Key';
      const appendIcon = this.credentialsShow[key]
        ? 'mdi-eye'
        : 'mdi-eye-off';
      const type = this.credentialsShow[key] ? 'text' : 'password';

      return {
        label: `LiveKit ${label}`,
        outlined: true,
        dense: true,
        appendIcon: appendIcon,
        type: type,
        autocomplete: 'off'
      };
    },
    toggleVisibleStatus(key: string): void {
      this.credentialsShow[key] = !this.credentialsShow[key];
    },

    parseSettingsData(
      data: TCopyStakeSettingsLiveKitCredentialsResponse
    ): void {
      const parsedData = {
        credentialsKey: String(data.credentialsKey ?? ''),
        credentialsSecret: String(data.credentialsSecret ?? ''),
        streamUrl: String(data.streamUrl ?? '')
      };

      this.credentialsSavedData = cloneDeep(parsedData);
      this.credentials = cloneDeep(parsedData);
    },

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getLiveKitCredentialsConfiguration()
        .then((data: TCopyStakeSettingsLiveKitCredentialsResponse) => {
          this.parseSettingsData(data);
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.credentialsShow.apiKey = false;
          this.credentialsShow.secretKey = false;

          this.isLoading = false;
        });
    },
    async updateConfiguration(): Promise<void> {
      const isFormValid = await this.$refs.form.validate();
      if (!isFormValid) return;

      this.isLoading = true;

      const payload: TCopyStakeSettingsLiveKitCredentialsPayload =
        this.credentials;

      await updateLiveKitCredentialsConfiguration(payload)
        .then((data: TCopyStakeSettingsLiveKitCredentialsResponse) => {
          this.parseSettingsData(data);

          this.$toast.success(
            'LiveKit Credentials was successfully updated!'
          );
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
